import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, CheckCircle2 } from "lucide-react";
import { fetchServices } from "../lib/api";
import { Icon } from "./shared";

export default function Services() {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchServices()
      .then((d) => setServices(d))
      .catch(() => setServices([]))
      .finally(() => setLoading(false));
  }, []);

  return (
    <section id="services" className="nst-light py-24 lg:py-32">
      <div className="max-w-[1280px] mx-auto px-6 lg:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-14">
          <div className="max-w-2xl">
            <span className="pill-label">Our Services</span>
            <h2 className="mt-6 text-4xl md:text-5xl lg:text-6xl font-extrabold text-[#0A1F47] leading-[1.05]">
              Engineering Solutions,<br />
              <span className="text-[#2E6BF6]">Not Just Services</span>
            </h2>
          </div>
          <p className="text-[#0A1F47]/70 text-base lg:text-lg max-w-md">
            We deliver production-grade platforms and automation frameworks designed for scale, reliability, and long-term operational success.
          </p>
        </div>

        {loading ? (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {[0, 1, 2, 3].map((i) => (
              <div key={i} className="h-80 bg-white/60 rounded-3xl animate-pulse" />
            ))}
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {services.map((s) => (
              <Link
                key={s.slug}
                to={`/services/${s.slug}`}
                className="group bg-white rounded-3xl p-8 md:p-10 border border-[#E2E8F4] card-lift hover:border-[#2E6BF6]/40 hover:shadow-[0_20px_60px_-20px_rgba(46,107,246,0.25)] block"
              >
                <div className="flex items-start justify-between mb-6">
                  <div className="w-14 h-14 rounded-2xl bg-[#EDF1FB] flex items-center justify-center group-hover:bg-[#2E6BF6] transition-colors">
                    <Icon name={s.icon} className="w-6 h-6 text-[#2E6BF6] group-hover:text-white transition-colors" />
                  </div>
                  <span className="w-10 h-10 rounded-full border border-[#0A1F47]/15 flex items-center justify-center group-hover:bg-[#0A1F47] group-hover:border-[#0A1F47] transition-colors">
                    <ArrowUpRight className="w-4 h-4 text-[#0A1F47] group-hover:text-white transition-colors" />
                  </span>
                </div>
                <h3 className="text-2xl md:text-[26px] font-bold text-[#0A1F47] leading-tight">
                  {s.title}
                </h3>
                <p className="mt-3 text-[#0A1F47]/70 leading-relaxed">{s.short_desc}</p>
                <ul className="mt-6 space-y-2.5 border-t border-[#E2E8F4] pt-6">
                  {s.bullets.map((b) => (
                    <li key={b} className="flex items-start gap-3 text-sm text-[#0A1F47]/80">
                      <CheckCircle2 className="w-[18px] h-[18px] text-[#2E6BF6] mt-0.5 flex-shrink-0" />
                      <span>{b}</span>
                    </li>
                  ))}
                </ul>
              </Link>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
